import { publicApi } from 'src/publicApi';

export enum ProfessionalRecordValidationFailureReason {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  INVALID_CRM = 'INVALID_CRM',
}

export enum EmailValidationFailureReason {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
}

export const getEmailValidationErrorMessage = (reason?: string): string => {
  if (!reason) {
    return 'Email inválido';
  }

  switch (reason) {
    case EmailValidationFailureReason.ALREADY_REGISTERED:
      return 'Este email já está cadastrado. ';
    default:
      return 'Email inválido';
  }
};

export interface DecodeTokenResponse {
  data: {
    document?: string;
    birthDate?: string;
    fullName?: string;
    professionalRecordIssuer?: 'CRM' | 'CRO';
    professionalRecordIssuerState?: string;
    professionalRecord?: string;
    phoneNumber?: string;
  };
}

export interface AutocompleteResponse {
  data: {
    document?: string;
    birthDate?: string;
    fullName?: string;
  };
}

export interface DecodeTokenPayload {
  token: string;
  params?: string;
}

export interface AutocompletePayload {
  document: string;
  birthDate: string;
}

export interface ValidatePersonPayload {
  document: string;
  birthDate: string;
}

export interface ValidatePersonResponse {
  isValid: boolean;
}

export interface ValidateProfessionalRecordPayload {
  number: string;
  uf: string;
  issuer: string;
  birthDate: string;
  document: string;
}

export interface ValidateProfessionalRecordResponse {
  data: {
    isValid: boolean;
    reason?: ProfessionalRecordValidationFailureReason | string;
  };
}

export const SignUpService = {
  async decodeToken(payload: DecodeTokenPayload): Promise<DecodeTokenResponse> {
    const { data } = await publicApi.post<DecodeTokenResponse>('/sign-up/user/decode', payload);
    return data;
  },

  async autocomplete(payload: AutocompletePayload): Promise<AutocompleteResponse> {
    const { data } = await publicApi.post<AutocompleteResponse>('/sign-up/user/autocomplete', payload);
    return data;
  },

  async validateProfessionalRecord(
    payload: ValidateProfessionalRecordPayload
  ): Promise<ValidateProfessionalRecordResponse> {
    const { data } = await publicApi.post<ValidateProfessionalRecordResponse>(
      '/sign-up/user/validate-professional-record',
      payload
    );
    return data;
  },
};
